import {createStyles, Theme} from "@material-ui/core";
import {primaryColor, styleColors, typography} from "src/main.style";
import {CHAT_PANE_TRANSITION_MS} from '@components/chat/ChatPane';

const CHAT_SEARCH_HEIGHT = '65px';
const BOTTOM_BAR_HEIGHT = '76px';

export const chatStyle = (theme: Theme) => createStyles({
  menuPaper: {
    borderRadius: '8px',
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[4],
  },
  menuList: {
    padding: theme.spacing(1, 0),
  },
  menuListItem: {
    ...typography.input,
  },
  menuItemTitle : {
    fontSize: '14px',
    fontWeight: 400,
    whiteSpace: 'normal',
    display:'flex',
    alignItems: 'center',
  },
  container : {
    maxHeight: '100vh',
    height: '100vh',
    minHeight: '100vh',
    width:'100vw',
    maxWidth:'100vw',
    minWidth:'100vw',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: styleColors.greyLight2,
  },
  search : {
    display: 'flex',
    minHeight: CHAT_SEARCH_HEIGHT,
    maxHeight: CHAT_SEARCH_HEIGHT,
    overflow:'hidden',
    minWidth:'100vw',
    maxWidth:'100vw',
    backgroundColor: styleColors.greyLight2,
    boxSizing: 'border-box',
    alignItems: 'flex-start',
  },
  searchBox : {
    display: 'flex',
    backgroundColor: styleColors.white,
    border: `0.5px solid ${styleColors.greyMedium1}`,
    borderRadius: '25px',
    flexGrow: 1,
    marginLeft: '32px',
    marginTop: '3px',
  },
  searchInput : {
    border: '0px',
    flexGrow: 1,
    marginLeft:'24px',
    marginRight:'6px',
    outline: '0px',
    fontSize:'16px',
    fontFamily: 'Metropolis',
    fontWeight: 300,
    /* Inherit the surface behind us — browser default is solid white. */
    backgroundColor: 'transparent',
    color: styleColors.greyDark2,
  },
  chatList : {
    display: 'flex',
    paddingTop: '12px',
    maxHeight: `calc(100vh - ${CHAT_SEARCH_HEIGHT} - ${BOTTOM_BAR_HEIGHT})`,
    minHeight: `calc(100vh - ${CHAT_SEARCH_HEIGHT} - ${BOTTOM_BAR_HEIGHT})`,
    borderRadius: '32px 32px 0px 0px',
    maxWidth: '100vw',
    minWidth: '100vw',
    overflowX: 'hidden',
    overflowY: 'auto',
    flexDirection: 'column',
    WebkitOverflowScrolling: 'touch',
    boxSizing: 'border-box',
    backgroundColor: styleColors.white,
    // Keep the trailing space scrollable and clear of the floating add button.
    '&::after': {
      content: '""',
      flex: '0 0 120px',
    },
  },
  chatRoomViewport : {
    maxWidth: '100vw',
    minWidth: '100vw',
    maxHeight: '100vh',
    minHeight: '100vh',
    position:'fixed',
    top:0,
    left:0,
    zIndex:100,
    display: 'flex',
    flexDirection: 'column',
  },
  chatRoomDetails : {
    width:'100%',
    flex:1,
    minHeight:0,
    position:'relative',
    display:'flex',
    flexDirection:'column',
    backgroundColor:styleColors.greyLight2,
    willChange:'transform',
    transition:`transform ${CHAT_PANE_TRANSITION_MS}ms cubic-bezier(0.22, 0.61, 0.36, 1)`,
    '@media (prefers-reduced-motion: reduce)': {
      transition:'none',
    },
  },
  FAB : {
    position: 'absolute',
    bottom: '100px',
    minWidth: '62px',
    minHeight: '62px',
    right: '20px',
    backgroundColor: primaryColor,
    color: '#FFFFFF',
    fontSize: '45px',
    zIndex: 1,
    borderRadius: '100px',
    transition: 'all 0.5s',
    boxShadow : `0px 3px 30px ${styleColors.fabShadow}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  bigDialog : {
    overflowX: 'hidden',
    minWidth: 'calc(100% - 16px)',
    position: 'relative',
  },
});



// WEBPACK FOOTER //
// ./src/containers/chat/chat2.container.style.ts